export default __webpack_public_path__ + "static/media/40c835802db2f6eef8af316564459640.svg";